import Scriba from 'react-scriba';

export class DataTrancheTravaux {

	static _chargementTranchesTravaux(idProgramme) {
		const objet = {
            "idProgramme": idProgramme
        };
        const url = "api/Liste/ListeDesTrancheTravaux";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementTrancheTravaux(idTrancheTravaux, idProgramme, idRegion, idAgence) {
        const objet = {
            "idTrancheTravaux": idTrancheTravaux,
            "idProgramme": idProgramme,
            "idRegion": idRegion,
            "idAgence": idAgence
        };
        const url = "api/Fiche/FicheTrancheTravaux";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementTrancheTravaux(trancheTravaux) {
        const url = "api/MAJDonnees/EnregistrementTrancheTravaux";
        const paramPost = Scriba.fetch().createParameterPost(trancheTravaux);
        return fetch(url, paramPost).then(response => response.json());
    }
}